import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-5 py-3 bg-background-50 border border-foreground-200 rounded-lg text-foreground-800 text-sm font-medium hover:border-primary-300 transition-colors duration-200 cursor-pointer whitespace-nowrap"
      >
        <span>Browse Categories</span>
        <i className={isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 w-64 bg-background-50 border border-foreground-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-foreground-900 transition-colors duration-150 cursor-pointer border-b border-background-200 last:border-b-0"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${cat.icon} text-base text-primary-500`}></i>
              </span>
              <span>{cat.name}</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}